import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Выгрузка для брокера',
      title: 'Выгрузка для брокера',
      executeAction: 'Подтвердить',
      errorMessage: 'Ошибка',
      successMessage: 'Запрос успешно отправлен',
      filterErrorMessage: 'Выберите любой фильтр по инвойсу',
    }
  }
}